import React from 'react';
import { DialogActions, DialogContent, DialogContentText, Button } from '@mui/material';
import {
  buttonsStyles,
  cancelButtonStyles,
  containerStyles,
  continueButtonStyles,
  labelFileNameStyles,
  labelStyles,
  progressStyles,
  uploadedFileNameStyles,
  uploadedFileSizeStyles
} from './processingMergeUploadDataset.styles';
import { IProcessingMergeUploadDataset } from './processingMergeUploadDataset.model';
import { removeLastExtension } from '../../../../../helpers/removeExtension';
import { MbConverter } from '../../../../../helpers/MbConverter';
import Progress from '../../../../../components/Progress';

const ProcessingMergeUploadDataset: React.FC<IProcessingMergeUploadDataset> = ({
  summaryData,
  setProcessingMergeActiveStep,
  processingMergeInputData,
  processingMergeUploadStatus,
  setProcessingMergeUploadStatus,
  processingMergeUploadProgress,
  setProcessingMergeUploadProgress,
  processingMergeUploadSucceeded
}) => {
  function onSubmit() {
    setProcessingMergeActiveStep(3);
    setProcessingMergeUploadProgress(0);
    setProcessingMergeUploadStatus('');
  }
  function handleBack() {
    setProcessingMergeActiveStep(1);
    setProcessingMergeUploadProgress(0);
    setProcessingMergeUploadStatus('');
  }

  return (
    <div style={containerStyles}>
      <span style={labelStyles}>
        Select a dataset to merge it with{' '}
        <span style={labelFileNameStyles}>{removeLastExtension(summaryData.filename)}</span>
      </span>
      <div style={uploadedFileNameStyles}>{removeLastExtension(processingMergeInputData?.uploadedFileName)}</div>
      <div style={uploadedFileSizeStyles}>({MbConverter(processingMergeInputData.uploadedFileSize)})</div>
      <DialogContent sx={progressStyles}>
        <DialogContentText>
          <Progress
            uploadStatus={processingMergeUploadStatus}
            progress={processingMergeUploadProgress}
            setPredictionProgress={setProcessingMergeUploadProgress}
          />
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={buttonsStyles}>
        <span style={cancelButtonStyles} onClick={handleBack}>
          Cancel
        </span>
        {processingMergeUploadProgress === 100 && (
          <span style={continueButtonStyles} onClick={onSubmit}>
            OK
          </span>
        )}
      </DialogActions>
    </div>
  );
};

export default ProcessingMergeUploadDataset;
